import React from 'react';

import {
  Paper,
  Typography,
  Grid,
} from '@material-ui/core';

import classes from '../../css/getCSS';

const quickSummary = (props) => {
  return (
    <React.Fragment>
      <Paper className={[classes.card, classes.cardFancy, classes.noBorderXS].join(' ')}>
        <Typography variant="subheading" className={classes.profileSectionTitle}>Quick Summary</Typography>
        <br />
        <Grid container>
          <Grid item md={12} sm={12} xs={12}>
            <p className={classes.profileCap}>About me</p>
            <p className={classes.profileVal}>{props.profile.personalinfo.about}</p>
            <br />
          </Grid>
          <Grid item md={6} sm={6} xs={12}>
            <p className={classes.profileCap}>Age</p>
            <p className={classes.profileVal}>{props.profile.personalinfo.age} years</p>
            <br />
          </Grid>
          <Grid item md={6} sm={6} xs={12}>
            <p className={classes.profileCap}>Height</p>
            <p className={classes.profileVal}>{props.profile.personalinfo.height}</p>
            <br />
          </Grid>
          <Grid item md={6} sm={6} xs={12}>
            <p className={classes.profileCap}>Marital Status</p>
            <p className={classes.profileVal}>
              {props.profile.personalinfo.marital_status
                ? props.profile.personalinfo.marital_status.label : '-'}
            </p>
            <br />
          </Grid>
          <Grid item md={6} sm={6} xs={12}>
            <p className={classes.profileCap}>Caste</p>
            <p className={classes.profileVal}>
              {props.profile.personalinfo.caste
                ? props.profile.personalinfo.caste.label : '-'}
            </p>
            <br />
          </Grid>
          <Grid item md={6} sm={6} xs={12}>
            <p className={classes.profileCap}>Education</p>
            <p className={classes.profileVal}>
              {props.profile.educationinfo.degree}
            </p><br />
          </Grid>
          <Grid item md={6} sm={6} xs={12}>
            <p className={classes.profileCap}>Work Profile</p>
            <p className={classes.profileVal}>
              {props.profile.educationinfo.work_profile
                ? props.profile.educationinfo.work_profile.label : '-'}
            </p>
            <br />
          </Grid>
        </Grid>
      </Paper>
    </React.Fragment>
  );
};


export default quickSummary;



// WEBPACK FOOTER //
// ./src/profile/components/ProfileQuickSummary.js